module.exports = __webpack_public_path__ + "img/aboutUs_img8.70d77adf.svg";